<nav class="navbar header-navbar pcoded-header" header-theme="theme4">
    <div class="navbar-wrapper">
        <div class="navbar-logo">
            <a class="mobile-menu" id="mobile-collapse" href="#!">
                <i class="ti-menu"></i>
            </a>
            <a class="mobile-search morphsearch-search" href="#">
                <i class="ti-search"></i>
            </a>
            <a [routerLink]="['/v2']">
                <img class="img-fluid" src="assets/images/logo.png" alt="Theme-Logo" />
            </a>
            <a class="mobile-options">
                <i class="ti-more"></i>
            </a>
        </div>
        <div class="navbar-container container-fluid">
            <div>
                <ul class="nav-left">
                    <li>
                        <div class="sidebar_toggle">
                            <a href="javascript:void(0)"><i class="ti-menu"></i></a>
                        </div>
                    </li>
                </ul>
                <div class="env-center-absolute">
                    <span style="color: orange; font-size: 26px; font-weight: bold;" *ngIf="ambiente === 1">
                        AMBIENTE: QA
                    </span>

                    <span style="color: orange; font-size: 26px; font-weight: bold;" *ngIf="ambiente === 2">
                        AMBIENTE: PRODUCCIÓN
                    </span>

                    <div class="env-bar mt-1" style="color: white;">
                        <span><b>Actividad:</b> {{ actividadVulnerable }}</span>
                        <span class="separator"> | </span>
                        <span><b>Razón Social:</b> {{ razonSocialNombre }}</span>
                        <span class="separator"> | </span>
                        <span><b>Almacén:</b> {{ almacenNombre }}</span>
                    </div>
                </div>

                <ul class="nav-right">
                    <li class="header-notification lng-dropdown" *ngIf="traduccion">
                        <a href="javascript:void(0)" id="dropdown-active-item">
                            <i class="flag-icon flag-icon-mx m-r-5" *ngIf="lang == 'es'"></i>
                            <i class="flag-icon flag-icon-us m-r-5" *ngIf="lang == 'en' "></i>
                            <i class="flag-icon flag-icon-fr m-r-5" *ngIf="lang == 'fr' "></i>
                            <i class="flag-icon flag-icon-pt m-r-5" *ngIf="lang == 'pt' "></i>
                        </a>
                        <ul class="show-notification">
                            <li>
                                <a href="javascript:void(0)" (click)="toogleLanguage('en')">
                                    <i class="flag-icon flag-icon-us m-r-5"></i> {{"seccion.comun.englishLabel" |
                                    translate }}
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" (click)="toogleLanguage('es')">
                                    <i class="flag-icon flag-icon-mx m-r-5"></i> {{"seccion.comun.spanishLabel" |
                                    translate }}
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" (click)="toogleLanguage('pt')">
                                    <i class="flag-icon flag-icon-pt m-r-5"></i> {{"seccion.comun.portuguesLabel" |
                                    translate }}
                                </a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" (click)="toogleLanguage('fr')">
                                    <i class="flag-icon flag-icon-fr m-r-5"></i> {{"seccion.comun.frenchLabel" |
                                    translate }}
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="user-profile header-notification">
                        <img src="assets/images/user.png" alt="User-Profile-Image" />
                        <span style="cursor: default; color: white;">
                            {{ user.nombre }} {{ user.sNombre }}
                        </span>
                        <i class="ti-angle-down"></i>

                        <ul class="show-notification profile-notification">

                            <!-- Visualizar Razones -->
                            <li>
                                <a routerLink="/v2/search-profile">
                                    <i class="ti-layout-sidebar-left"></i>
                                    Visualizar Razones
                                </a>

                            </li>

                            <li class="divider"></li>

                            <!-- Cerrar sesión -->
                            <li>
                                <a href="#" (click)="cerrarSesion()" *ngIf="traduccion">
                                    <i class="ti-layout-sidebar-left"></i>
                                    {{ "botones.cerrarsesion" | translate }}
                                </a>

                                <a href="#" (click)="cerrarSesion()" *ngIf="!traduccion">
                                    <i class="ti-layout-sidebar-left"></i>
                                    Cerrar sesión
                                </a>
                            </li>

                        </ul>
                    </li>

                </ul>
                <div id="morphsearch" class="morphsearch">
                    <form class="morphsearch-form">
                        <input class="morphsearch-input" type="search" placeholder="Search..." />
                        <button class="morphsearch-submit" type="submit">Search</button>
                    </form>
                    <div class="morphsearch-content">
                        <div class="dummy-column">
                            <h2>People</h2>
                            <a class="dummy-media-object" href="#!">
                                <img class="round"
                                    src="http://0.gravatar.com/avatar/81b58502541f9445253f30497e53c280?s=50&d=identicon&r=G"
                                    alt="Sara Soueidan" />
                                <h3>Sara Soueidan</h3>
                            </a>
                            <a class="dummy-media-object" href="#!">
                                <img class="round"
                                    src="http://1.gravatar.com/avatar/9bc7250110c667cd35c0826059b81b75?s=50&d=identicon&r=G"
                                    alt="Shaun Dona" />
                                <h3>Shaun Dona</h3>
                            </a>
                        </div>
                        <div class="dummy-column">
                            <h2>Popular</h2>
                            <a class="dummy-media-object" href="#!">
                                <img src="assets/images/avatar-1.png" alt="PagePreloadingEffect" />
                                <h3>Page Preloading Effect</h3>
                            </a>
                            <a class="dummy-media-object" href="#!">
                                <img src="assets/images/avatar-1.png" alt="DraggableDualViewSlideshow" />
                                <h3>Draggable Dual-View Slideshow</h3>
                            </a>
                        </div>
                        <div class="dummy-column">
                            <h2>Recent</h2>
                            <a class="dummy-media-object" href="#!">
                                <img src="assets/images/avatar-1.png" alt="TooltipStylesInspiration" />
                                <h3>Tooltip Styles Inspiration</h3>
                            </a>
                            <a class="dummy-media-object" href="#!">
                                <img src="assets/images/avatar-1.png" alt="NotificationStyles" />
                                <h3>Notification Styles Inspiration</h3>
                            </a>
                        </div>
                    </div>
                    <span class="morphsearch-close"><i class="icofont icofont-search-alt-1"></i></span>
                </div>
            </div>
        </div>
    </div>
</nav>